export default __webpack_public_path__ + "static/media/landscape21.156158bf.JPG";